import errors from "./errors.json"

export const getErrorMessage = (code: number): keyof typeof errors => {
    return (Object.keys(errors).find(
        (error) => errors[error as keyof typeof errors].code === code
    ) || "UnknownError") as keyof typeof errors
}

export const getErrorObject = (code: number) => {
    const errorMessage = getErrorMessage(code)
    return errors[errorMessage]
}

export { errors }
